import React from 'react';

const Services = () => {
    return (
        <section className="section section--services" id="services">
            <div className="container">
                <h2 className="section__title">Services Provided</h2>
                <p className="section__subtitle">
                    Reliable cleaning for homes, offices, and rentals using eco-friendly products.
                </p>

                <div className="services-grid">
                    <div className="service-card">
                        <div className="service-card__icon service-card__icon--home" />
                        <h3 className="service-card__title">Home</h3>
                        <p className="service-card__text">
                            Standard &amp; deep cleaning for houses and apartments. Kitchens, bathrooms,
                            living spaces &amp; more.
                        </p>
                        <a href="#quote" className="service-card__link">
                            Request Home Cleaning Quote
                        </a>
                    </div>

                    <div className="service-card">
                        <div className="service-card__icon service-card__icon--office" />
                        <h3 className="service-card__title">Office</h3>
                        <p className="service-card__text">
                            Reliable, discreet cleaning for offices &amp; workspaces. Keep your team in a
                            healthy, tidy environment.
                        </p>
                        <a href="#quote" className="service-card__link">
                            Request Office Cleaning Quote
                        </a>
                    </div>

                    <div className="service-card">
                        <div className="service-card__icon service-card__icon--rentals" />
                        <h3 className="service-card__title">Rentals</h3>
                        <p className="service-card__text">
                            Move-in / move-out, post-renovation &amp; rental turnovers so every guest
                            arrives to a spotless space.
                        </p>
                        <a href="#quote" className="service-card__link">
                            Request Rental Cleaning Quote
                        </a>
                    </div>
                </div>

                <p className="section__note">
                    Custom cleaning plans available — tell us what you need in your quote request.
                </p>
            </div>
        </section>
    );
};

export default Services;
